module.exports = __webpack_public_path__ + "Flaticon.b02b23073ebe9a57e484.eot";


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/assets/font/Flaticon.eot
// module id = ../../../../../src/assets/font/Flaticon.eot
// module chunks = styles